import { Language } from 'src/utils/constants'
import clsx from 'clsx'
import { Wrapper } from './youTubePlayer.styles'
import { YouTubePlayerProps } from './youTubePlayer.types'

const YouTubePlayer = ({
  id,
  title,
  autoplay = 0,
  rel = 1,
  showinfo = 1,
  hl = Language.EN,
  allowFullScreen = false,
  className
}: YouTubePlayerProps) => {
  const src = `https://www.youtube.com/embed/${id}?autoplay=${autoplay}&rel=${rel}&showinfo=${showinfo}&hl=${hl}`

  return (
    <Wrapper className={clsx(className, '_position-relative _d-block _overflow-hidden _border-0')}>
      <iframe
        className="_position-absolute _w-full _h-full"
        src={src}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen={allowFullScreen}
      />
    </Wrapper>
  )
}

export default YouTubePlayer
